var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTernLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 235,
    viewBox: "0 0 235 235",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.418,
    cy: 117.418,
    r: 117.418,
    fill: "#00C07F",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.996 167.944L55.4731 97.9807C70.0691 75.2235 84.8572 79.7211 91.0029 85.8717L98.8565 93.1669L141.884 59.1905C141.884 59.1905 143.856 57.2307 145.828 58.2131C147.8 59.1955 147.8 61.1555 147.8 61.1555V91.5593C147.8 91.5593 147.8 95.4824 145.828 97.4439C143.856 99.4055 139.614 103.329 139.614 103.329L119.562 118.667C124.043 123.408 130.143 129.848 141.513 140.458C151.464 149.744 157.356 145.46 162.945 140.244C163.742 139.5 164.656 138.786 166.338 138.786C168.021 138.786 170.079 141.83 170.079 141.83L178.581 155.023C178.581 155.023 179.601 156.376 179.941 158.067C180.281 159.759 178.241 161.45 178.241 161.45L172.459 167.201L167.261 171.98C151.59 183.666 132.102 174.158 124.996 167.944Z",
    fill: "#006D5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3102 80.1977C67.6244 81.1791 61.1672 90.0124 57.9387 94.9198C57.9387 94.9198 70.2285 88.7873 80.0095 91.0399C89.7905 93.2925 98.6189 92.9568 98.6189 92.9568C94.7446 88.7038 86.996 79.2162 77.3102 80.1977Z",
    fill: "#00C07F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTernLogo);
export default __webpack_public_path__ + "static/media/ternLogo.8ddf5fae870dd08dd8d2ce216fd2c4ea.svg";
export { ForwardRef as ReactComponent };